export const ASYNC_FETCH = 'ITP_MDNSelection/ASYNC_FETCH';
export const ASYNC_FETCH_SUCCESS = 'ITP_MDNSelection/ASYNC_FETCH_SUCCESS';
export const ASYNC_FETCH_FAILURE = 'ITP_MDNSelection/ASYNC_FETCH_FAILURE';
export const ASYNC_FETCH_INVALIDATE = 'ITP_MDNSelection/ASYNC_FETCH_INVALIDATE';
export const DEVICE_COMPATIBLE_CHECK = 'ITP_MDNSelection/DEVICE_COMPATIBLE_CHECK';
export const DEVICE_COMPATIBLE_FLAG = 'ITP_MDNSelection/DEVICE_COMPATIBLE_FLAG';
export const DEVICE_GO_BACK_FLAG = 'ITP_MDNSelection/DEVICE_GO_BACK_FLAG';
export const SET_SELECTED_MDN = 'ITP_MDNSelection/SET_SELECTED_MDN';
export const SET_SELECTED_MTNS = 'ITP_MDNSelection/SET_SELECTED_MTNS';
/**
 * action types
 * @type {string}
 */
